import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '@klickdata/core/user';
import { CustomerService } from '@klickdata/core/customer';
import { Utils } from '@klickdata/core/util';
import { Customer } from '@klickdata/core/customer';
import { User } from '@klickdata/core/user';
import { QuickAccess } from '@klickdata/core/quick-access';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { startWith, takeUntil } from 'rxjs';

@Component({
    selector: 'app-menu-side-add-navbar-quick-access',
    templateUrl: './menu-side-add-navbar-quick-access.component.html',
    styleUrls: ['./menu-side-add-navbar-quick-access.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideAddNavbarQuickAccessComponent extends OnDestroyHandler implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    public form: FormGroup;
    public context: FormControl = new FormControl('user');
    public customer_ids: FormControl = new FormControl([]);
    public rolesFormGroup: FormGroup;
    public allUserRoles: { [key: string]: string }[] = [];
    public customer: Customer;
    public user: User;
    public formArrayName: string;
    public existingQuickAccess: QuickAccess;
    constructor(
        protected fb: FormBuilder,
        protected userService: UserService,
        protected customerService: CustomerService
    ) {
        super();
        // this.allUserRoles = Utils.getAllRoles(['customeradmin', 'divisionadmin', 'groupadmin', 'instructor', 'user']);
    }

    ngOnInit(): void {
        this.user = this.navData.data.user;
        const roles = Utils.getUserRolesRelativeTo({
            role: this.user.role_value,
            allUserRolesSpecs: this.user.allUserRolesSpecs().filter((role) => role.value !== 'staff'),
            orEqual: false,
            returnFullSpecs: true,
            customerHasNODivisionMode: !this.navData.data.customer?.division_mode,
            comparison: 'lower',
        });
        this.allUserRoles = roles.map((role) => ({
            value: role.value,
            label: role.title,
        }));
        this.formArrayName = this.navData.data.formArrayName;
        this.rolesFormGroup = this.fb.group({});
        this.allUserRoles.forEach((role) => {
            this.rolesFormGroup.addControl(role.value, new FormControl(true));
        });

        this.form = this.fb.group({
            label: ['', Validators.required],
            route: ['', Validators.required],
            favorite: [false],
            navbar: [false],
        });
        this.customer_ids.patchValue([this.navData.data.customer.id]);

        this.context.valueChanges
            .pipe(takeUntil(this.destroy), startWith(this.context.value))
            .subscribe((value) => this.onCheckUpdates());

        this.form.get('route').patchValue(this.navData.data.route);
        this.form.get('route').disable();
        if (this.navData.data.availableNavbar) {
            this.form.get('navbar').patchValue(true);
        }
    }
    onUpdateCustomer(customers: Customer[]) {
        this.customer = customers[0];
        this.onCheckUpdates();
    }

    private onCheckUpdates() {
        this.getExistingQuickAccess(this.navData.data.route);
        if (!!this.existingQuickAccess) {
            this.form.get('label').patchValue(this.existingQuickAccess.label);
            this.form.get('favorite').patchValue(this.existingQuickAccess.favorite);
            this.form.get('navbar').patchValue(this.existingQuickAccess.navbar);
            this.form.get('route').patchValue(this.existingQuickAccess.route);
            if (!!this.existingQuickAccess.roles?.length) {
                this.rolesFormGroup.patchValue(
                    this.allUserRoles.reduce(
                        (acc, role) => ({
                            ...acc,
                            [role.value]: this.existingQuickAccess.roles?.includes(role.value) ?? false,
                        }),
                        {}
                    )
                );
            }
        }
    }
    getCheckedRoles(): string[] {
        return this.allUserRoles
            .filter((role) => this.rolesFormGroup.get(role.value)?.value === true)
            .map((role) => role.value);
    }

    getExistingQuickAccess(route: string): QuickAccess | undefined {
        if (!this.customer) {
            this.customer = this.navData.data.customer;
        }
        if (this.context.value === 'user' && !!this.user.metadata) {
            this.existingQuickAccess = this.user.metadata[this.formArrayName]?.find((qa) => qa.route === route);
        } else if (!!this.customer?.metadata) {
            this.existingQuickAccess = this.customer.metadata[this.formArrayName]?.find((qa) => qa.route === route);
        }
        return this.existingQuickAccess;
    }
    submit() {
        const formValues = this.form.getRawValue();
        const quickAccess = {
            label: formValues.label,
            route: formValues.route,
            favorite: formValues.favorite,
            navbar: formValues.navbar,
            enabled: true,
            order: 0,
        };

        if (this.context.value === 'user') {
            this.userService
                .update({
                    id: this.user.id,
                    metadata: { [this.formArrayName]: [quickAccess] },
                })
                .subscribe(() => this.onClose.emit());
        } else {
            if (this.context.value === 'customer') {
                quickAccess['roles'] = this.getCheckedRoles();
            } else {
                if ('roles' in quickAccess) {
                    delete quickAccess['roles'];
                }
            }

            this.customerService
                .update({
                    id: this.customer_ids.value[0],
                    metadata: {
                        [this.formArrayName]: [quickAccess],
                    },
                })
                .subscribe(() =>
                    this.onClose.emit(
                        this.context.value === 'specify'
                            ? { data: { route: formValues.route, customer_id: this.customer_ids.value[0] } }
                            : null
                    )
                );
        }
    }
}
